import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const commonRoutes = [
    { path: '/', redirect: '/home' },
    {
        path: '/home',
        name: 'home',
        meta: { title: '首页' },
        component: () => import('../views/Home.vue'),
    },
    {
        path: '/contact',
        name: 'contact',
        meta: { title: '联系我们' },
        component: () => import('../views/Contact.vue'),
    },
    {
        path: '/about',
        name: 'about',
        meta: { title: '关于源盛' },
        component: () => import('../views/About.vue'),
    },
    {
        path: '/news',
        name: 'news',
        meta: { title: '资讯中心' },
        component: () => import('../views/News.vue'),
    },
    {
        path: '/visa',
        name: 'visa',
        meta: { title: '签证移民' },
        component: () => import('../views/Visa.vue'),
    },
    {
        path: '/search',
        name: 'search',
        meta: { title: '搜索结果' },
        component: () => import('../views/Search.vue'),
    },
    {
        path: '/project-detail/:id?',
        name: 'project-detail',
        meta: { title: '项目详情' },
        component: () => import('../views/ProjectDetail.vue'),
    },
    {
        path: '/news-detail/:id?',
        name: 'news-detail',
        meta: { title: '资讯详情' },
        component: () => import('../views/NewsDetail.vue'),
    },
]

// 本地所有的页面 需要配合后台返回的数据生成页面
export const asyncRoutes = {}

const createRouter = () => new Router({
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        }

        return { x: 0, y: 0 }
    },
    routes: commonRoutes,
})

const router = createRouter()

export function resetRouter() {
    const newRouter = createRouter()
    router.matcher = newRouter.matcher
}

export default router
